import { DISCOUNT_SOFTENING_PROMO_CODE_DATA_V3, PROMO_CODE_DATA } from '../homeConfig'
import { useDiscountSofteningV3 } from '../useDiscountSofteningV3'

export function usePromoBannerText() {
  const isEnabled = useDiscountSofteningV3()

  return isEnabled ? DISCOUNT_SOFTENING_PROMO_CODE_DATA_V3 : PROMO_CODE_DATA
}
